/* eslint-disable max-len */
module.exports = {
  // Translations in this namespace are simple noun.
  account: '账号',
  account_id: '账号ID',
  owner_account_id: '主账号ID',
  sub_account_id: '子账号ID',
  grid: '网格',
  list: '列表',
  name: '名称',
  file: '文件',
  folder: '文件夹',
  local_file: '本地文件',
  local_folder: '本地文件夹',
  file_or_folder: '文件/文件夹',
  count_file_or_folder: '{count} 文件/文件夹',
  file_name: '文件名',
  folder_name: '文件夹名',
  basic_info: '基本信息',
  location: '位置',
  size: '大小',
  status: '状态',
  curr_status: '当前状态',
  action: '操作',
  remark: '备注',
  mtime: '修改时间',
  ctime: '创建时间',
  share: '分享',
  all: '全部',
  empty: '无',
  remain: '剩余',
  count_unit: '个',
  time_unit: {
    ms: '毫秒',
    s: '秒',
    min: '分钟',
    h: '小时',
    d: '天',
    y: '年',
  },
  status_code: '状态码',
  storage_method: '存储方式',
  url_link: 'Url 链接',
  file_detail: '文件详情',
  file_path: '文件路径',
  default_title: '提示消息',
  cloud_account_warning: '云梯子账号不允许使用永久密钥进行登录，请使用',
  account_disabled_secret_key: '请使用腾讯云账号登录，或安装 COSBrowser 客户端',
  account_disabled_oauth: '您的账号已禁用腾讯云账号登录，如有疑问请联系管理员。',
  session_expired: '登录态已失效，请重新登录。',
  tencent_cloud_account: '腾讯云账号>子用户',
  login_prompt: '登录！',
  login_title: '登录 COSBrowser',
  login_failed: '登录失败',
  return_to_login: '回到登录',
  missing_parameters: '缺少参数',
  file_size_exceeded: '文件大小超过限制，仅允许上传 {maxSize} 以内的文件',
  auth_failed: '授权失败，请重新登录。(授权过程中请勿刷新页面)',
  default_msg: '提示内容',
  success: '{msg}成功',
  fail: '{msg}失败',
  root: '存储桶列表', // '根目录',
  failure_list_type: '{type}失败列表',
  statistics: '统计',
  total: '总计',
  storage: '存储用量',
  link_type: '链接类型',
  url_type: '链接类型',
  resource: '资源',
  path: '路径',
  editor_history: '编辑器历史',
  original_name: '原文件(夹)名',
  off: '关闭',
  on: '开启',
  opened: '已开启',
  unopened: '未开启',
  valid_time: '有效时间',
  expire_time: '失效时间',
  extract_code: '提取码',
  table_layout: '表格布局',
  grid_layout: '网格布局',
  download_instructions: '下载说明',
  editor_mode: '编辑器模式',
  standard_mode: '标准模式',
  description: '描述',
  rule: '规则',
  type: '类型',

  // Translations in this namespace are simple actions.
  key_login: '密钥登录',
  login: '登录',
  logout: '退出登录',
  switch_session: '切换会话',
  copy: '复制',
  move: '移动',
  copyTo: '复制到',
  moveTo: '移动到',
  paste: '粘贴',
  restore: '恢复',
  del: '删除',
  remove: '删除',
  delete: '删除',
  delete_param: '删除{param}',
  select: '选中',
  select_all: '全选',
  edit: '编辑',
  refresh: '刷新',
  ok: '确定',
  cancel: '取消',
  close: '关闭',
  clear: '清空',
  clear_param: '清空{param}',
  start: '开始',
  pause: '暂停',
  replace: '覆盖',
  rename: '重命名',
  skip: '跳过',
  restart: '重试',
  resize: '还原',
  setting: '设置',
  use: '使用',
  download: '下载',
  upload: '上传',
  sync: '同步',
  tester: '测试',
  add: '添加',
  add_param: ['添加{param}', '{param}添加'],
  create: '新建',
  create_param: '新建{param}',
  save: '保存',
  saveAs: '另存为',
  noSave: '不保存',
  reset: '还原',
  open: '展开',
  minimize: '最小化',
  maximize: '最大化',
  restitute: '还原',
  transfer: '传输',
  change: '更改',
  more: '更多',
  hasMore: '还有更多',
  search: '搜索',
  detail: '详情',
  exif: 'EXIF',
  preview: '预览',
  searchType: {
    prefix: '前缀搜索',
    fuzzy: '模糊搜索',
    byBucketName: '名称',
    byBucketTag: '标签',
  },
  view: '查看',
  return: '返回',
  play: '播放',
  switch: '切换',
  import: '导入',

  // Translations in this namespace are complex actions.
  save_as: '另存为',
  pause_all: '暂停全部',
  start_all: '开始全部',
  remove_all: '删除全部',
  remove_finish: '清除已完成',
  load_more: '加载更多',
  no_more: '没有更多了',
  view_on_phone: '手机查看',
  file_preview: '文件预览',
  delete_files: '删除文件',
  upload_files: '上传文件',
  upload_folder: '上传文件夹',
  resume_upload_folder: '续传文件夹',
  create_file: '新建文件',
  create_folder: '新建文件夹',
  upload_advance: '高级上传',
  download_advance: '高级下载',
  download_whole_folder: '下载整个目录',
  setting_advance: '高级设置',
  copy_link: '复制链接',
  select_link: '选择链接',
  create_temp_link: '创建临时链接',
  select_objects: '选择上传对象',
  set_objects: '设置对象属性',
  drag_support: 'Chrome 和 FireFox 支持拖拽到此区域上传，支持选择多个文件/文件夹',
  drag_maxsize: '单个文件最大支持 512GB',
  select_file: '选择文件',
  select_folder: '选择文件夹',
  select_local_folder: '选择本地文件夹',
  create_link_task: '新建上传任务',
  add_link_task: '添加文件上传链接',
  cause_of_failure: '失败原因',
  select_target_folder: '选择目标目录',
  param_to_current_folder: '{param}到当前目录',
  only_show_once: '仅显示一次',
  clear_editor_history: '清空编辑历史',
  copy_files: '复制文件',
  move_files: '移动文件',
  share_file_or_folder: '文件/文件夹分享',
  auto_generate: '自动生成',
  custom: '自定义',
  preview_domain_configuration: '预览域名配置',
  copy_link_with_sign: '预览带签名',
  copy_link_without_sign: '预览不带签名',
  copy_link_and_extract: '链接：{url} 提取码：{extract}',
  copy_success: '已成功复制链接和提取码！',
  // Translations in this namespace are complex paragraph.
  step: ['下一步', '上一步'],
  list_param: '{action}列表',
  queue: '{action}队列',
  cost_time: '耗时',
  download_now: '立即下载',
  loading: '正在加载...',
  deleting: '删除中...',
  listing_files: '正在列出文件...',
  checking_files: '正在检查文件...',
  renaming_folder: '正在重命名文件夹...',
  loading_thumbnail: '正在加载缩略图...',
  consistency_checking: '正在进行一致性校验...',
  list_empty: '列表为空',
  keyword_empty: '关键字为空',
  I_know_it: '我知道了',

  // 同步操作 相关名词
  sync_file: '文件同步',
  sync_setting: '同步设置',
  sync_log: '同步日志',
  sync_start: '开始同步',
  sync_stop: '停止同步',
  sync_auto: '自动同步',
  sync_clear_cache: '清除本地缓存',
  sync_clear_cache_success: '本地缓存已清除',
  sync_tip1: '开启同步后，若存储桶路径上存在与本地重名的文件，COSBrowser 将执行覆盖操作',
  sync_tip2: '如您不希望覆盖，可在存储桶中开启',
  sync_clear_history: '清空历史记录',
  sync_history_empty: '没有历史记录',
  sync_success_param: '{count} 个文件成功',
  sync_fail_param: '{count} 个文件失败',
  sync_scanning: '正在扫描文件...',
  sync_no_changed: '没有文件更新',
  sync_syncing: '有 {count} 个文件更新，正在上传...',
  sync_current_time: '本次同步',
  sync_tips:
    '仅支持将本地文件夹同步至存储桶目录，具体规则请查看 <a href="https://cloud.tencent.cn/document/product/436/38103#synchronization">说明文档</a>',
  sync_last_time_param: '上次同步于{duration}前',
  sync_state_map: {
    waiting_hash: '等待中',
    waiting_upload: '等待上传',
    hashing: '校验中',
    uploading: '正在上传',
    paused: '已暂停',
    canceled: '已取消',
    error: '同步出错',
    success: '上传成功',
    no_change: '与远端一致',
  },
  no_files_upload: '没有需要上传的文件',

  // 状态相关名词
  state_map: {
    start: '开始{action}',
    waiting: '等待{action}',
    checking: '文件校验中',
    doing: [
      '正在{action}', // 0
      '{action}中', // 1
      '正在{action}文件', // 2
    ],
    paused: '暂停{action}',
    canceled: '取消{action}',
    fail: '{action}失败',
    success: '{action}完成', // 0
  },
  share_permission_map: {
    r: '只读',
    rw: '读写',
  },

  // 句子
  delete_incomplete: '删除未完成',
  deleting_files: '批量删除中，已删除 {count} 个文件...',
  delete_files_success: '成功删除 {count} 个文件/文件夹。',
  delete_files_summary: '总共 {count} 个文件，{success} 个文件删除成功，{fail} 个文件删除失败。',
  delete_files_paragraph: [
    '总共 {count} 个文件',
    '{count} 个文件删除成功',
    '{count} 个文件删除失败',
    '{count} 个文件未成功删除',
  ],
  start_to_end_file: '第 {start}-{end} 个文件，',
  get_url_link: '获取 Url 链接文件...',
  search_result: ['前缀搜索关键字" {keyword} ",已搜索到 {result} 个结果', '模糊搜索关键字" {keyword} ",已检索 {num} 个文件，{result} 个结果', '名称搜索到 {result} 个结果', '标签搜索到 {result} 个结果', '已检索 {num} 个文件，{result} 个结果'],
  sort_result: ['排序中，已加载 {result} 个文件', '已加载并排序 {result} 个文件', '已加载并排序 {result} 个文件，已达上限'],
  data_statistics_deadline: '数据统计截止时间点：{time}',
  download_mobile_client: '扫码下载手机客户端',
  only_show_200_record: '仅显示200条记录',
  get_no_password_from_system: '未从系统中取到密码，是否刷新界面？',
  open_with_encode_param: '以 {encode} 编码打开',
  open_with_other_encode: '以其他编码格式打开',
  convert_to_encode_param: '转为 {encode} 编码',
  convert_to_other_encode: '转为其他编码格式',
  keep_historical_record_param: '仅保存 {num} 条历史记录',
  confirm_delete_record: '确定删除副本 {name}？',
  confirm_clear_edit_history: '确定清空编辑历史？（一旦清空，初始编辑文件无法再找回）',
  confirm_to_save: '是否仍要保存？',
  params_be_pasted: '将要粘贴 {num} 个文件/文件夹。',
  conflict_paste: '目标位置已经包含以下同名文件/文件夹，请选择你的操作：',
  share_folders_name_params: '{name}',

  // 分页
  pagination: {
    items: '项',
    item: '项',
    checked: '已选',
    total: '共',
    linesPerPage: '每页显示行',
    firstPage: '第一页',
    previousPage: '上一页',
    nextPage: '下一页',
    lastPage: '最后一页',
    pageIndex: '第 {index} 页',
    itemPulled: '已拉取 <strong>{num}</strong> 项',
  },

  // 编辑文件
  edit_exit_tips: '文件已修改，是否保存？',
  edit_reading_file: '正在读取文件',
  edit_reading_error: '读取文件出错',
  still_edit: '仍然编辑',
  edit_unsaved: '未保存',
  edit_saving: '正在保存',

  // 图片EXIF属性
  exif_name: '名称',
  exif_explanation: '说明',
  exif_value: '值',
  exif_map: {
    ExifVersion: 'Exif 版本',
    FlashPixVersion: 'FlashPix 版本',
    ColorSpace: '色域、色彩空间',
    PixelXDimension: '图像的有效宽度',
    PixelYDimension: '图像的有效高度',
    ComponentsConfiguration: '图像构造',
    CompressedBitsPerPixel: '压缩时每像素色彩位',
    MakerNote: '制造商设置的信息',
    UserComment: '用户评论',
    RelatedSoundFile: '关联的声音文件',
    DateTimeOriginal: '创建时间',
    DateTimeDigitized: '数字化创建时间',
    SubsecTime: '日期时间（秒）',
    SubsecTimeOriginal: '原始日期时间（秒）',
    SubsecTimeDigitized: '原始日期时间数字化（秒）',
    ExposureTime: '曝光时间',
    FNumber: '光圈值',
    ExposureProgram: '曝光程序',
    SpectralSensitivity: '光谱灵敏度',
    ISOSpeedRatings: '感光度',
    OECF: '光电转换功能',
    ShutterSpeedValue: '快门速度',
    ApertureValue: '镜头光圈',
    BrightnessValue: '亮度',
    ExposureBiasValue: '曝光补偿',
    MaxApertureValue: '最大光圈',
    SubjectDistance: '物距',
    MeteringMode: '测光方式',
    Lightsource: '光源',
    Flash: '闪光灯',
    SubjectArea: '主体区域',
    FocalLength: '焦距',
    FlashEnergy: '闪光灯强度',
    SpatialFrequencyResponse: '空间频率反应',
    FocalPlaneXResolution: '焦距平面X轴解析度',
    FocalPlaneYResolution: '焦距平面Y轴解析度',
    FocalPlaneResolutionUnit: '焦距平面解析度单位',
    SubjectLocation: '主体位置',
    ExposureInde: '曝光指数',
    SensingMethod: '图像传感器类型',
    FileSource: '源文件',
    SceneType: '场景类型',
    CFAPattern: 'CFA 模式',
    CustomRendered: '自定义图像处理',
    ExposureMode: '曝光模式',
    WhiteBalance: '白平衡',
    DigitalZoomRation: '数字变焦',
    FocalLengthIn35mmFilm: '35毫米胶片焦距',
    SceneCaptureType: '场景拍摄类型',
    GainControl: '场景控制',
    Contrast: '对比度',
    Saturation: '饱和度',
    Sharpness: '锐度',
    DeviceSettingDescription: '设备设定描述',
    SubjectDistanceRange: '主体距离范围',
    ImageUniqueID: '图像唯一ID',
    ImageWidth: '图像宽度',
    ImageHeight: '图像高度',
    BitsPerSample: '比特采样率',
    Compression: '压缩方法',
    PhotometricInterpretation: '像素合成',
    Orientation: '拍摄方向',
    SamplesPerPixel: '像素数',
    PlanarConfiguration: '数据排列',
    YCbCrSubSampling: '色相抽样比率',
    YCbCrPositioning: '色相配置',
    XResolution: 'X方向分辨率',
    YResolution: 'Y方向分辨率',
    ResolutionUnit: '分辨率单位',
    StripOffsets: '图像资料位置',
    RowsPerStrip: '每带行数',
    StripByteCounts: '每压缩带比特数',
    JPEGInterchangeFormat: 'JPEG SOI 偏移量',
    JPEGInterchangeFormatLength: 'JPEG 比特数',
    TransferFunction: '转移功能',
    WhitePoint: '白点色度',
    PrimaryChromaticities: '主要色度',
    YCbCrCoefficients: '颜色空间转换矩阵系数',
    ReferenceBlackWhite: '黑白参照值',
    DateTime: '日期和时间',
    ImageDescription: '图像描述',
    Make: '生产者',
    Model: '型号',
    Software: '软件',
    Artist: '作者',
    Copyright: '版权信息',
    GPSVersionID: 'GPS 版本',
    GPSLatitudeRef: '南北纬',
    GPSLatitude: '纬度',
    GPSLongitudeRef: '东西经',
    GPSLongitude: '经度',
    GPSAltitudeRef: '海拔参照值',
    GPSAltitude: '海拔',
    GPSTimeStamp: 'GPS 时间戳',
    GPSSatellites: '测量的卫星',
    GPSStatus: '接收器状态',
    GPSMeasureMode: '测量模式',
    GPSDOP: '测量精度',
    GPSSpeedRef: '速度单位',
    GPSSpeed: 'GPS 接收器速度',
    GPSTrackRef: '移动方位参照',
    GPSTrack: '移动方位',
    GPSImgDirectionRef: '图像方位参照',
    GPSImgDirection: '图像方位',
    GPSMapDatum: '地理测量资料',
    GPSDestLatitudeRef: '目标纬度参照',
    GPSDestLatitude: '目标纬度',
    GPSDestLongitudeRef: '目标经度参照',
    GPSDestLongitude: '目标经度',
    GPSDestBearingRef: '目标方位参照',
    GPSDestBearing: '目标方位',
    GPSDestDistanceRef: '目标距离参照',
    GPSDestDistance: '目标距离',
    GPSProcessingMethod: 'GPS 处理方法名',
    GPSAreaInformation: 'GPS 区功能变数名',
    GPSDateStamp: 'GPS 日期',
    GPSDifferential: 'GPS 修正',
  },
  // 元数据
  meta_data: '元数据',
  meta_val: '值',
  meta_params: '参数',
  meta_option: '操作',
  meta_add_params: '添加参数',
  meta_select_project: '选择项目',
  meta_delete: '删除',
  meta_option_tips: '对象属性设置将应用到所有待上传的对象上，您也可上传完成后在文件列表页直接设置。',

  // 归档取回
  recovery_mode: '恢复模式',
  restore_mode_standard: '标准 - Standard',
  restore_mode_expedited: '极速 - Expedited',
  restore_mode_bulk: '批量 - Bulk',
  restore_archived_objects: '恢复已被归档或深度归档的对象',
  no_later_than: '最晚于 {time} 后可下载副本',
  extreme_speed_mode_only_supports_objects_within_256MB: '极速模式仅支持 256MB 以内对象',
  restore_copy_validity: '副本有效期',
  please_enter_the_number_of_days: '请输入天数',
  the_copy_will_be_automatic_expired_deletion: '副本将于 {time} 自动过期删除',
  recovery_input_rules: '请输入整数天数，最小为1，最大为365',
  resortErrorMessage: {
    notArchive: '该文件不是归档存储',
  },
  restore_estimated_time: '预期时间',
  restore_the_copy_can_be_downloaded: '于恢复模式预期时间后可下载副本',
  restore_the_copy_will_be_deleted: '副本将于 {deleteTime} 后自动过期删除',
  restore_the_restored_copy_will_be_deleted: '副本已取回，副本将于{deleteTime}后自动过期删除',
  restore_copy_rescheduled: '副本改期',
  restore_copy_time_map: {
    standard: '标准模式 3~5 小时',
    expedited: '极速模式 1~5 分钟',
    bulk: '批量模式 5~12 小时',
  },
  restore_status_map: {
    unrestore: '归档存储',
    restoring: '副本恢复中',
    restored: '副本已恢复',
  },
  urlUpload: '链接上传',
  collection_path: '收藏的路径',
  bucket_list: '存储桶列表',
  favorite: '收藏',
  unfavorite: '取消收藏',
  ErrorCode: '错误码',
  PrefixConfiguration: '前缀匹配',
  TencentCloud: '腾讯云',
  EtgError: 'get ETag error, please add "ETag" to CORS ExposeHeader setting.( 获取ETag失败，请在CORS ExposeHeader设置中添加ETag，请参考文档：https://cloud.tencent.com/document/product/436/13318 )',
  ContentLengthError: 'get Content-Length error, please add "Content-Length" to CORS ExposeHeader setting.（ 获取Content-Length失败，请在CORS ExposeHeader设置中添加Content-Length，请参考文档：https://cloud.tencent.com/document/product/436/13318 ）',
  NoSuchSid: '当前分享链接不存在',
  ExpiredUrl: '当前分享链接已失效',
  ErrorExtractCode: '提取码错误，请重新输入',
  GetAccessCodeWrong: '解码失败，请重试',
  PleaseEnterCode: '请输入 6 位的提取码',
  InternetError: '网络繁忙，请刷新页面',
  LoginExpireTime: '登录已过期，请重新登录。',
  PleaseEnterKeyAndValue: '请填写完整标签键和标签值',
  EnterProductError: '标签键不能以 项目、project、qcs: 开头',
  MaxKey127: '标签键长度不能大于 127 字符',
  MaxKey255: '标签值长度不能大于 255 字符',
  KeyRepeat: '标签键不允许重复',
};
